
import {
    TweenLite
} from 'gsap'
import {
    computed,
    defineComponent,
    reactive,
    ref
} from 'vue'
export default defineComponent({
    name: 'CigoThermometerOne',
    setup(props, ctx) {
        const sliderMinX = 0
        const sliderMaxX = 240

        const coldGradient = {
            start: '#5564C2',
            end: '#3A2E8D'
        }
        const hotGradient = {
            start: '#F0AE4B',
            end: '#9B4D1B'
        }
        let dragging = ref(false);
        let initialMouseX = 0;
        let initialSliderX = 0;
        let sliderX = ref(0);
        let temperatureGrades = [10, 15, 20, 25, 30];
        let bgColorObj = reactive({
            start: coldGradient.start,
            end: coldGradient.end
        });

        const startDrag = (e: any) => {
            dragging.value = true;
            initialMouseX = e.pageX;
            initialSliderX = sliderX.value;

            window.addEventListener('mousemove', mouseMoving);
            window.addEventListener('touchmove', mouseMoving);
            window.addEventListener('mouseup', stopDrag);
            window.addEventListener('touchend', stopDrag);
            window.addEventListener('contextmenu', stopDrag);
        };
        const stopDrag = () => {
            dragging.value = false;

            window.removeEventListener('mousemove', mouseMoving);
            window.removeEventListener('touchmove', mouseMoving);
            window.removeEventListener('mouseup', stopDrag);
            window.removeEventListener('touchend', stopDrag);
            window.removeEventListener('contextmenu', stopDrag);
        };
        const mouseMoving = (e: any) => {
            if (dragging.value) {
                const dragAmount = e.pageX - initialMouseX;
                const targetX = initialSliderX + dragAmount;

                // keep slider inside limits
                sliderX.value = Math.max(Math.min(targetX, sliderMaxX), sliderMinX);

                // set bg color
                let targetGradient = coldGradient
                if (currentTemperature.value >= 25) {
                    targetGradient = hotGradient
                }
                if (bgColorObj.start !== targetGradient.start) {
                    TweenLite.to(bgColorObj, 1, {
                        'start': targetGradient.start,
                        'end': targetGradient.end
                    })
                }
            }
        };
        const tempElementStyle = (tempNumber: number) => {
            const nearDistance = 3
            const liftDistance = 12

            // lifts up the element when the current temperature is near it
            const diff = Math.abs(currentTemperature.value - tempNumber)
            const distY = (diff / nearDistance) - 1

            // constrain the distance so that the element doesn't go to the bottom
            const elementY = Math.min(distY * liftDistance, 0)
            return `transform: translate3d(0, ${elementY}px, 0)`
        };

        let currentTemperature = computed(() => {
            return (sliderX.value / sliderMaxX * 20) + 10;
        });

        const round = (num: number) => {
            return Math.round(num);
        };

        let sliderStyle = computed(() => {
            return `transform: translate3d(${sliderX.value}px,0,0)`
        });
        let bgColor = computed(() => {
            return `linear-gradient(to bottom right, ${bgColorObj.start}, ${bgColorObj.end})`
        });

        return {
            temperatureGrades,
            currentTemperature,
            round,
            bgColor,
            tempElementStyle,
            sliderStyle,
            startDrag,
            dragging,
        };
    }
})
